import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateTwentyPDFSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateTwentyPDFSection themeColor={themeColor} heading={heading}>
      <View>{summary && <ResumePDFText>{summary}</ResumePDFText>}</View>
    </TemplateTwentyPDFSection>
  );
};
